export const isABiggerThanB = (aStr, bStr) => {
	const a = Number(aStr.replace(":", "."));
	const b = Number(bStr.replace(":", "."));
	return a > b ? a : b;
};

export const timeIntervals = () => {
	// Time intervals list in 15mins
	const timeIntervalList = [];
	const startTime = "00:00";
	const endTime = "23:45";
	const start = startTime.split(":");
	const end = endTime.split(":");
	const startHour = parseInt(start[0]);
	const endHour = parseInt(end[0]);
	const startMinute = parseInt(start[1]);
	const endMinute = parseInt(end[1]);

	for (let i = startHour; i <= endHour; i++) {
		let hour = i;
		let minute = startMinute;
		while (minute <= endMinute) {
			let time = `${hour < 10 ? "0" + hour : hour}:${
				minute < 10 ? "0" + minute : minute
			}`;
			timeIntervalList.push({ value: time, label: time });
			minute += 15;
		}
	}
	// Format time to 12hr
	timeIntervalList.forEach((time, index) => {
		const [hours, minutes] = time.value.split(":");
		const hour = parseInt(hours);
		const minute = parseInt(minutes);
		const ampm = hour >= 12 ? "pm" : "am";
		const hour12 = hour % 12 || 12;
		const formattedTime = `${hour12}:${minute < 10 ? "0" + minute : minute} ${
			ampm === "pm" ? "PM" : "AM"
		}`;
		timeIntervalList[index].label = formattedTime;
	});
	return timeIntervalList.map(({ value, label }) => ({
		value: `${value}:00`,
		label,
	}));
};

export const to12hr = (time) => {
	try {
		const [hours, minutes] = time.split(":");
		const hour = parseInt(hours);
		const minute = parseInt(minutes);
		const ampm = hour >= 12 ? "pm" : "am";
		const hour12 = hour % 12 || 12;
		const formattedTime = `${hour12}:${minute < 10 ? "0" + minute : minute} ${
			ampm === "pm" ? "PM" : "AM"
		}`;
		return formattedTime;
	} catch (error) {
		return time;
	}
};

export const sortTimeIntervals = (timeIntervals) => {
	return timeIntervals.sort((a, b) => isABiggerThanB(a.value, b.value));
};

export const toSingleTimeRange = (intervals) => {
	const timeRange = [];
	const timeIntervals = timeIntervals();
	const timeIntervalsValues = timeIntervals.map((time) => time.value);
	intervals.forEach((interval) => {
		const [start, end] = interval.split("-");
		const startIndex = timeIntervalsValues.indexOf(start);
		const endIndex = timeIntervalsValues.indexOf(end);
		const timeRange = timeIntervals.slice(startIndex, endIndex + 1);
		timeRange.forEach((time) => {
			if (!timeRange.includes(time)) timeRange.push(time);
		});
	});
	return timeRange;
};